import { gmRequest } from './';

export default {
  getRisingStarPageContent: (year = '') => gmRequest(`/api/cms/rising-star/${year}`),
};
